import React, { useContext, useEffect, useState } from 'react';
import ImageSection from './common/ImageSection';
import LoginInputs from './LoginInputs';
import { motion } from 'framer-motion'
import { FetchContext } from '../Context/fetchContext';
import LoadingModal from './LoadingModal';
import ErrorModal from './ErrorModal';

const LoginLanding = ({ HeadingText, subHeadingText, subHeadingHighlight, img, loginBar1, loginBar2, loginBar3, person }) => {
    const fetchContext = useContext(FetchContext);
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const [schData, setSchData] = useState(null)

    const host = fetchContext.host; 

    const imageSectionVariants = {
        hidden: {
            opacity: 0
        },
        visible: {
            opacity: 1
        },
        transition: {duration:1}
    };

    useEffect(() => {
        const getSchData = async () => {
            try {
              setLoading(true);
              const { data } = await fetchContext.getRoute(`getsubschools/${host}`);
              console.log(data);
              if(data.status) {
                setLoading(false);
                setSchData(data.data.schoolDetails)
                localStorage.setItem('schoolData', data.data)
              } else {
                setLoading(false);
                setError(data.message);
                console.log(data.message);
              }
            } catch (error) {
                setLoading(false);
                setError('Something Went Wrong');
                console.log(error);
            }
        };

        getSchData();
        return () => {
            
        }
    }, [fetchContext, host])

    return (
        <>
            {loading && <LoadingModal />}
            {error && <ErrorModal errMsg={error} />}
            <div className='flex w-full'>
                <div className='hidden lg:block relative w-full h-screen'>
                    <motion.div variants={imageSectionVariants} animate='visible' initial="hidden" exit="exit" className='fixed w-45'>
                        <ImageSection 
                            headingText = {HeadingText} 
                            subHeadingText = {subHeadingText} 
                            subHeadingHighlight = {subHeadingHighlight}
                            img = {img} 
                        />
                    </motion.div>
                </div>
                <div className='w-full lg:hidden relative'>
                    <img src={img} alt="relevantImg" className="object-cover bg-fixed w-full h-screen" />
                </div>
                <div className='inset-0 overflow-x-hidden lg:pt-8 px-4 lg:px-12 w-full w-55 absolute lg:top-0 left-auto lg:right-0'>
                    <div className='w-full lg:w-full mx-auto h-full'>
                        <LoginInputs 
                            loginBar1 = {loginBar1}
                            loginBar2 = {loginBar2}
                            loginBar3 = {loginBar3}
                            educator 
                            person = {person}
                            schLogo = {schData && schData.defaultSchoolloogo}
                            schName = {schData && schData.defaultSchoolName}
                        />
                    </div>
                </div>
            </div>
        </>
    )
}

export default LoginLanding;